import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { ReactMarkdown, } from 'react-markdown/lib/react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { theme } from '../../theme';
/**
 * This component will render a Markdown text.
 */
export var Markdown = function (props) {
    return (_jsx(ReactMarkdown, __assign({ remarkPlugins: [remarkGfm], rehypePlugins: [rehypeRaw], components: {
            img: function (_a) {
                var alt = _a.alt, otherProps = __rest(_a, ["alt"]);
                return _jsx("img", __assign({ style: { maxWidth: '100%' }, alt: alt }, otherProps));
            },
            pre: function (preProps) {
                return _jsx("pre", __assign({ style: { maxWidth: '100%' } }, preProps));
            },
            a: function (_a) {
                var children = _a.children, otherProps = __rest(_a, ["children"]);
                return (_jsx("a", __assign({ target: "_blank", rel: "noreferrer", style: {
                        textDecoration: 'none',
                        color: theme.palette.customBlue.main,
                    } }, otherProps, { children: children })));
            },
            code: function (codeProps) {
                return (_jsx("code", __assign({ style: {
                        display: 'block',
                        maxWidth: '100%',
                        whiteSpace: 'break-spaces',
                        fontFamily: 'monospace',
                        backgroundColor: '#f4f4f4',
                    } }, codeProps)));
            },
            table: function (_a) {
                var children = _a.children, otherProps = __rest(_a, ["children"]);
                return (_jsx("table", __assign({ style: {
                        borderSpacing: 0,
                        borderCollapse: 'collapse',
                        display: 'block',
                        width: '100%',
                        overflow: 'auto',
                    } }, otherProps, { children: children })));
            },
            th: function (_a) {
                var children = _a.children, otherProps = __rest(_a, ["children"]);
                return (_jsx("th", __assign({ style: {
                        padding: '6px 13px',
                        border: '1px solid #ccc',
                    } }, otherProps, { children: children })));
            },
            td: function (_a) {
                var children = _a.children, otherProps = __rest(_a, ["children"]);
                return (_jsx("td", __assign({ style: {
                        padding: '6px 13px',
                        border: '1px solid #ccc',
                    } }, otherProps, { children: children })));
            },
            tr: function (_a) {
                var children = _a.children, otherProps = __rest(_a, ["children"]);
                var isNthChild2n = otherProps.node.position.start.line % 2 === 0;
                return (_jsx("tr", __assign({ style: {
                        backgroundColor: isNthChild2n ? '#fff' : '#f4f4f4',
                        borderTop: '1px solid #eee',
                    } }, otherProps, { children: children })));
            },
        } }, props)));
};
